import {
  CreateThirdPartyBillingAccountSchema,
  ThirdPartyBillingAccountSchema,
} from "@redotech/redo-fulfillment-carrier-account-common/third-party-billing-accounts";
import * as z from "zod";

export const createThirdPartyBillingAccount = {
  name: "createThirdPartyBillingAccount" as const,
  input: CreateThirdPartyBillingAccountSchema.omit({ team: true }),
  output: z.object({ account: ThirdPartyBillingAccountSchema }),
};
